import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/category/latest-entry', label: t('nav.latest') },
    { to: '/category/usage-tutorial', label: '使用教程' },
    { to: '/category/safety-guide', label: '安全指南' },
    { to: '/about', label: t('nav.about') },
  ];

  const categories = [
    { to: '/category/latest-entry', label: '最新入口' },
    { to: '/category/usage-tutorial', label: '使用教程' },
    { to: '/category/safety-guide', label: '安全指南' },
    { to: '/category/common-issues', label: '常见问题' },
    { to: '/category/mobile-guide', label: '移动端指南' },
    { to: '/category/tools-resources', label: '工具资源' },
  ];

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-qr-code-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                草榴二维码
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {t('footer.disclaimer')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              {t('footer.quickLinks')}
            </h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              {t('footer.categories')}
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.to}>
                  <Link
                    to={cat.to}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              {t('footer.contact')}
            </h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-400">
              <a href="mailto:contact@caoliu-qrcode.example.com" className="hover:text-primary-400 transition-colors duration-200">
                <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-mail-line"></i>
                </div>
                contact@caoliu-qrcode.example.com
              </a>
              <p>
                <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-wechat-line"></i>
                </div>
                微信公众号：草榴二维码指南
              </p>
              <p>
                <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-qq-line"></i>
                </div>
                QQ群：888888888
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {t('footer.copyright')}. {t('footer.rights')}.
          </p>
          <div className="flex items-center gap-3">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/30 text-foreground-400 hover:text-primary-400 hover:bg-foreground-800/50 transition-colors duration-200" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/30 text-foreground-400 hover:text-primary-400 hover:bg-foreground-800/50 transition-colors duration-200" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/30 text-foreground-400 hover:text-primary-400 hover:bg-foreground-800/50 transition-colors duration-200" aria-label="RSS" rel="nofollow">
              <i className="ri-rss-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}